import React, { useEffect, useRef, useState } from "react";
import AddVenueEnquiry from "../../Components/Rfp/AddVenueEnquiry";
import { Link, useHistory, useLocation } from "react-router-dom";
import VenueCard from "../../Components/Rfp/VenueCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import Warning from "../../Components/Warning";
import { getWidth } from "redux-window";
import { connect, useSelector } from "react-redux";
import { Field, getFormValues, reduxForm } from "redux-form";
import { Toggle } from "../../Components/Form";
import { isCompanyUser, isSuperAgent } from "../../modules/permissions";
import { isAgency, isIndividual } from "../../modules/auth";
import { ENQUIRY_STATUS, ROCHE_THIRD_PARTY_TEXT } from "../../constants";
import { ButtonSpan } from "../../Components/Button";
import classnames from "classnames";
import AddFromShortlist from "../../Components/Rfp/AddFromShortlist";
import AddShortlistEnquiry from "../../Components/Rfp/AddShortlistEnquiry";
import MatchingVenuesSearch from "../../Components/Rfp/MatchingVenuesSearch";

const Enquiry = ({
  venues = [],
  windowSize,
  offerRfpXpress,
  form,
  isCompanyUser,
  isIndividual,
  enquiry,
  addVenueToDraftEnquiry,
  removeVenueFromEnquiry,
  isExternalAgency,
  setSubmitToAgent,
  isAgency,
  setFormDisabled,
  formDisabled,
  showFormToggle,
  hasShortlists,
  roomStyleOptions = [],
}) => {
  const { xs, sm, md } = windowSize;
  const values = useSelector(getFormValues(form));
  const [warningText, setWarningText] = useState("");
  const [chosenVenues, setChosenVenues] = useState([]);
  const [maxVenues, setMaxVenues] = useState(5);
  const [suggestVenues, setSuggestVenues] = useState(false);
  const [showMatchingVenues, setShowMatchingVenues] = useState(false);
  const [matchingVenuesCount, setMatchingVenuesCount] = useState(0);
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const sectionRef = useRef(null);
  const [navOffset, setNavOffset] = useState(0);

  useEffect(() => {
    const header = document.querySelector("header");
    if (!header) {
      return;
    }
    const updateNavOffset = () =>
      setNavOffset(Math.ceil(header.getBoundingClientRect().height));
    updateNavOffset();
    const observer = new ResizeObserver(updateNavOffset);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  const stickyTop = Math.max(navOffset - 1, 0);

  const scrollToTabs = () => {
    if (sectionRef.current) {
      const top =
        sectionRef.current.getBoundingClientRect().top +
        window.scrollY -
        stickyTop;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };
  useEffect(() => {
    if (isAgency && venues && venues.length === 0) {
      setShowMatchingVenues(true);
    } else if (!isExternalAgency && venues && venues.length === 0) {
      setSuggestVenues(true);
      setSubmitToAgent(true);
    }

    if (queryParams.get("tab") && queryParams.get("tab") === "startWithBrief") {
      setSuggestVenues(true);
      setShowMatchingVenues(false);
    }
  }, []);

  useEffect(() => {
    if (!suggestVenues && chosenVenues.length > 0) {
      chosenVenues.map(venue => {
        addVenueToEnquiry(venue.id);
      });
    } else if (suggestVenues) {
      history.replace({
        search: "",
      });
    }
  }, [suggestVenues]);

  useEffect(() => {
    if (venues.length > 0) {
      setChosenVenues(venues);
      setSuggestVenues(false);
      setShowMatchingVenues(false);
    } else if (isAgency) {
      if (
        queryParams.get("tab") &&
        queryParams.get("tab") === "startWithBrief"
      ) {
        setSuggestVenues(true);
        setShowMatchingVenues(false);
      } else {
        setChosenVenues([]);
        setShowMatchingVenues(true);
      }
    } else if (!isExternalAgency) {
      setChosenVenues([]);
      setSuggestVenues(true);
    }
  }, [venues]);

  useEffect(() => {
    if (!isAgency) {
      if (maxVenues === 2 && venues.length >= 3) {
        setWarningText(
          "You can have a maximum of 2 venues when submitting an RFP"
        );
      } else if (venues.length >= 6) {
        setWarningText(
          "You can have a maximum of 5 venues when submitting an RFP"
        );
      } else {
        setWarningText("");
      }
    }
  }, [maxVenues, venues]);

  useEffect(() => {
    if (!isAgency) {
      if (
        Boolean(offerRfpXpress) &&
        values &&
        Boolean(values.rfp_xpress_service)
      ) {
        setMaxVenues(2);
      } else {
        setMaxVenues(5);
      }
    }
  }, [offerRfpXpress, values]);

  const removeVenue = venueId => {
    if (enquiry) {
      removeVenueFromEnquiry(venueId);
    } else if (
      queryParams.has("venues") &&
      queryParams.toString().includes(venueId)
    ) {
      let venuesArray = queryParams.get("venues").split(",");
      let filteredVenues = venuesArray.filter(id => {
        return Number(id) !== Number(venueId);
      });
      queryParams.set("venues", filteredVenues.join());
      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  const addVenueToEnquiry = venueId => {
    setSubmitToAgent(false);
    if (enquiry) {
      addVenueToDraftEnquiry(venueId);
      return;
    }
    let venuesArray = [];
    if (queryParams.has("venues")) {
      venuesArray = queryParams.get("venues").split(",");
      venuesArray.unshift(venueId);
      let filteredArray = [...new Set(venuesArray)].filter(v => v !== "");
      if (filteredArray.length === 1) {
        queryParams.set("venues", filteredArray[0]);
      } else {
        queryParams.set("venues", filteredArray.join());
      }
    } else {
      venuesArray.unshift(venueId);
      queryParams.set("venues", venuesArray[0]);
    }
    history.replace({
      search: queryParams.toString(),
    });
  };

  const slides =
    venues &&
    venues
      .sort((a, b) => {
        let sortOrder = queryParams.has("venues")
          ? queryParams.get("venues").split(",")
          : [];
        return (
          sortOrder.indexOf(String(a.id)) - sortOrder.indexOf(String(b.id))
        );
      })
      .map(venue => {
        return (
          <SwiperSlide key={venue.id}>
            <VenueCard
              venue={venue}
              removeVenue={removeVenue}
              canRemove={
                venues.length > 1 &&
                (!enquiry ||
                  (enquiry &&
                    enquiry.enquiry_status.code === ENQUIRY_STATUS.DRAFT))
              }
            />
          </SwiperSlide>
        );
      });

  const toggleForm = () => {
    if (!showFormToggle) {
      return null;
    } else {
      return (
        <div className="mb-5">
          <div className="px-3 py-6 my-5 block font-bold bg-lighter-blue">
            {ROCHE_THIRD_PARTY_TEXT}
            <div className="pt-4">
              <p>I confirm this booking is not for a Third Party Meeting</p>
              <div
                className="flex text-xs"
                style={{
                  lineHeight: "26px",
                  height: "28px",
                }}
              >
                <ButtonSpan
                  className={classnames(
                    "inline-block flex items-center px-3 border border-grey-md border-r-0",
                    {
                      "opacity-50": formDisabled,
                      "bg-brand": !formDisabled,
                    }
                  )}
                  onClick={() => setFormDisabled(false)}
                >
                  YES
                </ButtonSpan>
                <ButtonSpan
                  className={classnames(
                    "inline-block flex items-center px-3 border border-grey-md",
                    {
                      "opacity-50": !formDisabled,
                      "bg-brand": formDisabled,
                    }
                  )}
                  onClick={() => setFormDisabled(true)}
                >
                  NO
                </ButtonSpan>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {toggleForm()}
      <div ref={sectionRef} />
      <div className="sticky z-10 bg-white shadow" style={{ top: stickyTop }}>
        <div className="flex items-stretch">
          <div className="flex flex-1">
            <div
              onClick={() => {
                setSuggestVenues(false);
                setShowMatchingVenues(false);
                scrollToTabs();
              }}
              className={`item pt-3 pb-2 px-2 flex-1 cursor-pointer rounded-t-lg ${
                !suggestVenues && !showMatchingVenues
                  ? "bg-off-white hover:text-black"
                  : "hover:text-brand"
              }`}
            >
              <p
                className="font-bold text-center mb-0 text-xs uppercase flex items-center justify-center"
                style={{ gap: "0.5rem" }}
              >
                I have chosen venues for my event
                {venues.length > 0 && (
                  <span
                    className="inline-block bg-primary text-white text-xs font-bold rounded-full px-2 py-0"
                    style={{ lineHeight: "18px", minWidth: "22px" }}
                  >
                    {venues.length}
                  </span>
                )}
              </p>
            </div>
            {!isExternalAgency ? (
              <div
                onClick={() => {
                  setSuggestVenues(true);
                  setShowMatchingVenues(false);
                  scrollToTabs();
                }}
                className={`item pt-3 pb-2 px-2 flex-1 cursor-pointer rounded-t-lg ${
                  suggestVenues && !showMatchingVenues
                    ? "bg-off-white hover:text-black"
                    : "hover:text-brand"
                }`}
              >
                <p className="font-bold text-center mb-0 text-xs uppercase">
                  {isAgency
                    ? "Start with a Brief"
                    : "I want an agent to suggest suitable venues"}
                </p>
              </div>
            ) : null}
            {isAgency ? (
              <div
                onClick={() => {
                  setSuggestVenues(false);
                  setShowMatchingVenues(true);
                  scrollToTabs();
                }}
                className={`item pt-3 pb-2 px-2 flex-1 cursor-pointer rounded-t-lg ${
                  showMatchingVenues
                    ? "bg-off-white hover:text-black"
                    : "hover:text-brand"
                }`}
              >
                <p
                  className="font-bold text-center mb-0 text-xs uppercase flex items-center justify-center"
                  style={{
                    gap: "0.25rem",
                    flexDirection: xs || sm ? "column" : "row",
                  }}
                >
                  Venues which match your brief
                  {matchingVenuesCount > 0 && (
                    <span
                      className="bg-primary text-white text-xs font-bold rounded-full px-2 py-0"
                      style={{
                        lineHeight: "18px",
                        minWidth: "22px",
                        display: xs || sm ? "block" : "inline-block",
                      }}
                    >
                      {matchingVenuesCount}
                    </span>
                  )}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="mb-6 pb-3">
        {isAgency && (
          <div
            className={showMatchingVenues ? "py-6 px-3 bg-off-white" : "hidden"}
          >
            <MatchingVenuesSearch
              form={form}
              onCountChange={setMatchingVenuesCount}
              roomStyleOptions={roomStyleOptions}
              onAddVenue={addVenueToEnquiry}
              onRemoveVenue={removeVenue}
              addedVenueIds={venues.map(v => v.id)}
            />
          </div>
        )}
        {!showMatchingVenues && !suggestVenues ? (
          <div className="py-6 px-3 bg-off-white">
            <div className="row mb-0">
              {!enquiry ||
              (enquiry &&
                enquiry.enquiry_status.code === ENQUIRY_STATUS.DRAFT &&
                !isIndividual &&
                !isCompanyUser) ? (
                <div className={"col lg:col-w-1/2"}>
                  <AddVenueEnquiry
                    addVenue={addVenueToEnquiry}
                    disableAdd={warningText !== ""}
                  />
                </div>
              ) : null}
              {(!enquiry && hasShortlists) ||
              (enquiry &&
                enquiry.enquiry_status.code === ENQUIRY_STATUS.DRAFT &&
                !isIndividual &&
                !isCompanyUser &&
                hasShortlists) ? (
                <div className={"col lg:col-w-1/2"}>
                  <AddShortlistEnquiry
                    addVenue={addVenueToEnquiry}
                    disableAdd={warningText !== ""}
                  />
                </div>
              ) : null}
              {offerRfpXpress && isAgency ? (
                <div className={"col lg:col-w-1/2"}>
                  <Field
                    name="rfp_xpress_service"
                    label="Produce Budget Confirmation (Xpress)"
                    wrapperClassName="w-full mb-8 mr-2"
                    component={Toggle}
                    defaultValue={enquiry?.rfp_xpress_service}
                  />
                </div>
              ) : null}

              {venues.length === 0 ? (
                <Warning className="my-4 w-full mx-3">
                  <p className="text-md text-white mb-0">
                    <i className="fas text-2lg fa-exclamation-triangle mr-3" />
                    You need to select venues to request a proposal. You can use
                    an{" "}
                    <Link
                      to="/admin/my-edge/shortlists"
                      className={"text-white font-bold hover:underline"}
                    >
                      existing shortlist
                    </Link>{" "}
                    or{" "}
                    <Link
                      to="/advanced-search"
                      className={"text-white font-bold hover:underline"}
                    >
                      create one here
                    </Link>
                  </p>
                </Warning>
              ) : null}
              {offerRfpXpress ? (
                <div className="ml-3 mr-3 mt-0 mb-3 p-3 bg-lighter-blue w-full">
                  <p className={"mb-0"}>
                    <i className="fas text-2lg fa-info-circle mr-3" />
                    Please note: Xpress Enquiry service can only include 2
                    venues (8 hour SLA, Mon-Fri 9-5pm)
                  </p>
                </div>
              ) : null}
            </div>
            {maxVenues && warningText !== "" ? (
              <Warning className="mb-4">
                <p className="text-md text-white mb-0">
                  <i className="fas text-2lg fa-exclamation-triangle mr-3" />
                  {warningText}
                </p>
              </Warning>
            ) : null}
            <div className="row">
              <div className="col mt-2">
                <Swiper
                  spaceBetween={20}
                  slidesPerView={xs || sm ? 1.25 : md ? 2.25 : 2.75}
                  centerInsufficientSlides={false}
                >
                  {slides}
                </Swiper>
              </div>
            </div>
          </div>
        ) : !showMatchingVenues ? (
          <div className="p-6 bg-off-white">
            {offerRfpXpress && isAgency ? (
              <div className={"col lg:col-w-1/2"}>
                <Field
                  name="rfp_xpress_service"
                  label="Produce Budget Confirmation (Xpress)"
                  wrapperClassName="w-full mb-8 mr-2"
                  component={Toggle}
                  defaultValue={enquiry?.rfp_xpress_service}
                />
              </div>
            ) : null}
            <div className="p-3 bg-lighter-blue w-full">
              <p className={"mb-0"}>
                <i className="fas text-2lg fa-info-circle mr-3" />
                {isAgency
                  ? 'Once you\'ve filled in the brief below and submitted it, you can search, shortlist and add venues to the brief. Alternatively, to match venues as you input your brief select "Venues which match my brief" and add your venues.'
                  : "Once you've filled in the brief below and submitted it to an agent, your agency contact will review the brief and suggest up to4 suitable venues for you to approve to receive the brief."}
              </p>
            </div>
            {offerRfpXpress ? (
              <div className="mt-2 p-3 bg-lighter-blue w-full">
                <p className={"mb-0"}>
                  <i className="fas text-2lg fa-info-circle mr-3" />
                  Please note: Xpress Enquiry service will only include 1
                  suggested venue (8 hour SLA, Mon-Fri 9-5pm)
                </p>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};

const mapStateToProps = state => {
  const width = getWidth(state);
  return {
    windowSize: {
      xs: width < 576,
      sm: width >= 576 && width < 768,
      md: width >= 768 && width < 1200,
    },
    isCompanyUser: isCompanyUser(state),
    isExternalAgency: isAgency(state) && !isSuperAgent(state.auth),
    isIndividual: isIndividual(state),
    isAgency: isAgency(state),
    hasShortlists: state.auth.shortlists.length > 0,
  };
};

export default reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(connect(mapStateToProps, null)(Enquiry));
